import React from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../../../components/common/PageHeader";
import SearchBar from "../../../../components/common/SearchBar";
import { useRestaurantConfig } from "../../../../utils/restaurantConfig";

/**
 * Product List Header Component
 * Displays the page header with search, create button, and navigation
 */
const ProductListHeader = ({ searchQuery, onSearchChange, onManageTiming }) => {
  const navigate = useNavigate();
  const { features } = useRestaurantConfig();

  return (
    <PageHeader
      showBackButton={true}
      backTo={-1}
      title="Products"
      subtitle={
        <span className="flex items-center gap-2">
          <span className="inline-block w-2 h-2 bg-blue-500 rounded-full"></span>
          Manage your menu items and inventory
        </span>
      }
      action={
        <div className="flex flex-wrap items-center justify-end gap-2 sm:gap-3 mt-3 sm:mt-0 w-full">
          {/* Bulk Upload Button */}
          <button
            title="Bulk Upload"
            onClick={() => navigate("/product/bulk-upload")}
            className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium px-3 py-2 sm:px-4 rounded-lg transition-colors duration-200 flex items-center gap-2 shadow-sm hover:shadow-md border border-gray-300"
          >
            <svg
              className="hidden sm:block w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1M16 12l-4-4m0 0l-4 4m4-4v12"
              />
            </svg>
            <span className="hidden sm:inline">Bulk Upload</span>
            <span className="sm:hidden text-xs font-semibold">Bulk</span>
          </button>
          
          {/* Manage Timing Button */}
          {features?.availableTimeManage !== false && (
            <button
              title="Manage Timing"
              onClick={onManageTiming}
              className="bg-indigo-50 hover:bg-indigo-100 text-indigo-700 font-medium px-3 py-2 sm:px-4 rounded-lg transition-colors duration-200 flex items-center gap-2 shadow-sm border border-indigo-200"
            >
              <svg className="hidden sm:block w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="hidden sm:inline">Manage Timing</span>
              <span className="sm:hidden text-xs font-semibold">Time</span>
            </button>
          )}

          {/* Create Product Button */}
          <button
            title="Create New Product"
            onClick={() => navigate("/product/add")}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-3 py-2 sm:px-4 rounded-lg transition-colors duration-200 flex items-center gap-2 shadow-sm hover:shadow-md"
          >
            <svg
              className="hidden sm:block w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            <span className="hidden sm:inline">Create New Product</span>
            <span className="sm:hidden text-xs font-semibold">Create</span>
          </button>
        </div>
      }
      search={
        <SearchBar
          value={searchQuery}
          onChange={onSearchChange}
          placeholder="Search products by name, category, or subcategory..."
          className="max-w-lg"
        />
      }
    />
  );
};

export default ProductListHeader;
